import axios from 'axios';

export interface WarehouseReceivePayload {
  sizeQuantities: Record<string, number>;
  stockQuantity: number;
  location: string;
  physicallyReceived: boolean;
}

export const submitWarehouseReceive = (productId: string, payload: WarehouseReceivePayload) => {
  return axios.post(`/products/${productId}/warehouse-receive`, payload);
};
